import { getUpdateSchedulesFunction } from 'components/Templates/product/ProductEditTemplate'
import { Dispatch, SetStateAction, useCallback } from 'react'
import { ScheduleType } from 'types/schedule'
import { StockUnionType } from 'types/stock'

const useToggleScheduleType = (
  setDailySchedules: Dispatch<SetStateAction<ScheduleType[]>>,
  setPreorderSchedules: Dispatch<SetStateAction<ScheduleType[]>>
): ((value: string, type: StockUnionType) => void) => {
  return useCallback(
    (value: string, type: StockUnionType) => {
      const update = getUpdateSchedulesFunction(type, setDailySchedules, setPreorderSchedules)
      if (!update) return
      update((prevState) => {
        const nextState = prevState.map((schedule) => {
          schedule.maximum_order = Number(value)
          return schedule
        })
        return [...nextState]
      })
    },
    [setDailySchedules, setPreorderSchedules]
  )
}

export default useToggleScheduleType
